import React, { useEffect, useState } from 'react';
import moment from 'moment';
import MyRigs from './MyRigs';
import { deleteBdNoId, getTableByIdBd } from '../config/functions';
import { LoaderES } from './LoaderES';

const Home = ({ 
    broken, collapsed, rig, setRig, setComponente, mobile, user, uid, colors, tipo, reportes,
    // Tab props (solo desktop)
    openTabs, setOpenTabs, activeTabId, setActiveTabId, showRigSelector, setShowRigSelector,
    // Cache props
    getCachedRigData, setCachedRigData, updateCachedRigData, clearCachedRigData,
    // Lista de rigs
    rigs,
    // Theme
    theme
}) => {

    const [taladrosUsuario, setTaladrosUsuario] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [asignaciones, setAsignaciones] = useState(false)
    const [rigsData, setRigsData] = useState([]);

    // Estado local inicializado con prop rig o localStorage
    const [localSelectedRig, setLocalSelectedRig] = useState(() => {
        // Prioridad: 1) prop rig, 2) localStorage, 3) null
        if (rig !== undefined && rig !== null) {
            return rig;
        }
        try {
            const storedRig = localStorage.getItem('rig');
            return storedRig ? parseInt(storedRig) : null;
        } catch (error) {
            console.warn('Error leyendo rig de localStorage:', error);
            return null;
        }
    });

    // Sincronizar estado local cuando cambie la prop rig
    useEffect(() => {
        if (rig !== undefined && rig !== null && rig !== localSelectedRig) {
            setLocalSelectedRig(rig);
        }
    }, [rig, localSelectedRig]);

    useEffect(() => { getRigs() }, [])

    const getRigs = async () => {

        function verificarDuplicados(arr) {
            const visto = {};
            for (let i = 0; i < arr.length; i++) {
                if (visto[arr[i].nb_tldro_idn]) return true;
                visto[arr[i].nb_tldro_idn] = true;
            }
            return false;
        }

        setIsLoading(true)
        try {
            const data = await getTableByIdBd(uid, 'getrigsusers')
            if (data.length >= 1) {
                const duplicados = verificarDuplicados(data)
                if (duplicados) setAsignaciones(true)
                setTaladrosUsuario(data)
            }
        } catch (error) {
        } finally {
            setIsLoading(false)
        }
    }

    // Procesar datos para crear estructura de tarjetas
    useEffect(() => {
        if (taladrosUsuario && taladrosUsuario.length > 0) {
            const rigsMap = {};

            // Filtrar datos válidos y procesarlos
            const validData = taladrosUsuario.filter(item => {
                const transmissionDate = moment(item.dt_adt_last_fchreg);
                return transmissionDate.isValid() && !transmissionDate.format().includes('Invalid');
            });

            validData.forEach(item => {
                const [rigName, wellName] = item.vr_tldro_nom.split('-');
                const lastTransmission = moment(item.dt_adt_last_fchreg);

                if (!rigsMap[rigName]) {
                    rigsMap[rigName] = {
                        name: rigName,
                        wells: [],
                        lastTransmissionDate: lastTransmission
                    };
                }

                if (wellName) {
                    rigsMap[rigName].wells.push({
                        id: item.nb_tldro_idn,
                        name: wellName,
                        fullName: item.vr_tldro_nom,
                        description: item.vr_tldro_des === 'TAladro no configurado, creado automáticamente por el sistemaaa' ? 'Sin Descripción' : item.vr_tldro_des,
                        startDate: moment(item.dt_adt_fchreg).format('DD-MM-YY HH:mm'),
                        lastTransmission: lastTransmission.format('DD-MM-YY HH:mm'),
                        lastTransmissionDate: lastTransmission,
                        tx: item.tx
                    });

                    // Actualizar fecha más reciente del rig
                    if (lastTransmission.isAfter(rigsMap[rigName].lastTransmissionDate)) {
                        rigsMap[rigName].lastTransmissionDate = lastTransmission;
                    }
                }
            });

            // Convertir a array y ordenar rigs por fecha más reciente
            const rigsArray = Object.values(rigsMap).sort((a, b) =>
                b.lastTransmissionDate.valueOf() - a.lastTransmissionDate.valueOf()
            );

            // Ordenar pozos dentro de cada rig por fecha más reciente
            rigsArray.forEach(rigData => {
                rigData.wells.sort((a, b) =>
                    b.lastTransmissionDate.valueOf() - a.lastTransmissionDate.valueOf()
                );
            });

            setRigsData(rigsArray);
        }
    }, [taladrosUsuario]);

    const handleRigClick = (rigId) => {
        setRig(parseInt(rigId));
    };

    const handleWellClick = (wellId) => {
        const numericWellId = parseInt(wellId);
        setRig(numericWellId);
        setLocalSelectedRig(numericWellId);
    };

    const handleNavigation = (wellId, component) => {
        setRig(parseInt(wellId));
        setComponente(component);
    };

    //----------------------------

    const eliminarAsignacionesDuplicadas = async () => {
        try {
            await deleteBdNoId('asignacionesduplicadas')
            getRigs()
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => { if (asignaciones) eliminarAsignacionesDuplicadas() }, [asignaciones])

    // Verificar inicialización cuando los datos estén listos
    useEffect(() => {
        if (rigsData.length > 0) {
            const currentRig = rig !== undefined ? rig : localSelectedRig;

            // Si no hay rig seleccionado, intentar recuperar de localStorage
            if (!currentRig) {
                try {
                    const storedRig = localStorage.getItem('rig');
                    if (storedRig) {
                        const numericRig = parseInt(storedRig);
                        setLocalSelectedRig(numericRig);
                    }
                } catch (error) {
                    // Silencioso - no mostrar error
                }
            }
        }
    }, [rigsData, rig, localSelectedRig]);

    //---------------------------

    return (
        taladrosUsuario.length === 0 || isLoading
            ? <LoaderES />
            : mobile
                ? <MyRigs
                    broken={broken}
                    collapsed={collapsed}
                    rig={rig}
                    setRig={setRig}
                    setComponente={setComponente}
                    mobile={mobile}
                    user={user}
                    uid={uid}
                    colors={colors}
                    tipo={tipo}
                    reportes={reportes} />
                : <div className="container-fluid py-4" style={{
                    backgroundColor: colors?.colorBg || 'transparent',
                    color: colors?.grColorFont || '#212529'
                }}>
                    <div className="row">
                        <div className="col-12">
                            <div className="text-center mb-4">
                                <h2 className="mb-2" style={{
                                    color: colors?.grColorFont || '#0d6efd'
                                }}>Mis Taladros y Pozos</h2>
                                <p style={{
                                    color: colors?.grColorFont ? `${colors.grColorFont}99` : '#6c757d',
                                    opacity: 0.85
                                }}>Selecciona un pozo para navegar directamente a gráficas, datos o reportes</p>
                            </div>
                        </div>
                    </div>

                    <div className="row g-4">
                        {rigsData.map((rigData, index) => {
                            // Verificar si algún pozo de este rig está seleccionado
                            const hasSelectedWell = rigData.wells.some(well => rig === well.id);

                            return (
                                <div key={index} className="col-xl-4 col-lg-6 col-md-12">
                                    <div className={`card shadow-sm h-100 border`}
                                        style={{
                                            backgroundColor: colors?.colorBg || 'transparent',
                                            borderColor: hasSelectedWell 
                                                ? colors?.colorFont || '#6c757d'
                                                : colors?.grColorFont ? `${colors.grColorFont}30` : '#dee2e6',
                                            borderWidth: hasSelectedWell ? '2px' : '1px',
                                            ...(hasSelectedWell && {
                                                boxShadow: `0 0 0 2px ${colors?.colorFont || '#6c757d'}20`
                                            })
                                        }}>
                                        <div className="card-header text-white d-flex justify-content-between align-items-center position-relative"
                                            style={{
                                                backgroundColor: hasSelectedWell
                                                    ? colors?.colorFont || '#0d6efd'
                                                    : colors?.colorFont ? `${colors.colorFont}99` : '#6c757d',
                                                borderRadius: '0.375rem 0.375rem 0 0',
                                                ...(hasSelectedWell && {
                                                    boxShadow: `inset 0 0 10px ${colors?.colorFont || '#0d6efd'}40`
                                                })
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <i className={`fas fa-industry me-2 fs-5 ${hasSelectedWell ? 'text-warning' : ''
                                                    }`}></i>
                                                <h5 className="card-title mb-0 fw-bold">{rigData.name}</h5>
                                                {hasSelectedWell && (
                                                    <i className="fas fa-star text-warning ms-2 fa-sm"></i>
                                                )}
                                            </div>
                                            <span className={`badge rounded-pill px-3 py-2`}
                                                style={{
                                                    backgroundColor: hasSelectedWell ? '#ffc107' : (colors?.colorBg ? `${colors.grColorFont}30` : '#f8f9fa'),
                                                    color: hasSelectedWell ? '#000' : (colors?.grColorFont || '#212529')
                                                }}>
                                                <i className="fas fa-oil-well me-1"></i>
                                                {rigData.wells.length} pozos
                                            </span>
                                        </div>

                                        <div className="card-body p-0">
                                            <div className="list-group list-group-flush">
                                                {rigData.wells.map((well, wellIndex) => {
                                                    // Usar prop rig o estado local como fallback
                                                    const currentRig = rig !== undefined ? rig : localSelectedRig;
                                                    const isSelected = currentRig === parseInt(well.id) || String(currentRig) === String(well.id);
                                                    const hasDescription = well.description && well.description !== 'Sin Descripción';

                                                    return (
                                                        <div
                                                            key={wellIndex}
                                                            className={`list-group-item py-3 px-3 position-relative ${isSelected
                                                                    ? 'shadow border border-3 border-warning'
                                                                    : 'border-start'
                                                                }`}
                                                            style={{
                                                                cursor: 'pointer',
                                                                transition: 'all 0.2s ease',
                                                                ...(isSelected ? {
                                                                    backgroundColor: colors?.colorBg ? `${colors.colorBg}40` : '#f8f9fa',
                                                                    borderLeftColor: colors?.colorFont || '#0d6efd',
                                                                    borderLeftWidth: '4px',
                                                                    transform: 'translateX(3px)',
                                                                    boxShadow: `0 2px 8px ${colors?.colorFont || '#0d6efd'}20`,
                                                                    borderRadius: '6px',
                                                                    margin: '2px 0'
                                                                } : {
                                                                    borderLeftWidth: '2px',
                                                                    borderLeftColor: colors?.grColorFont || '#dee2e6',
                                                                    backgroundColor: colors?.colorBg || 'transparent'
                                                                })
                                                            }}
                                                            onClick={() => handleWellClick(well.id)}
                                                        >


                                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                                <div className="d-flex align-items-center flex-grow-1">
                                                                    <div className="me-3">
                                                                        <i className={`fas fa-oil-well fs-5`}
                                                                            style={{
                                                                                color: isSelected
                                                                                    ? colors?.colorFont || '#0d6efd'
                                                                                    : colors?.grColorFont || '#6c757d'
                                                                            }}></i>
                                                                    </div>
                                                                    <div className="flex-grow-1">
                                                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                                                            <div className={`fw-bold fs-6`}
                                                                                style={{
                                                                                    color: isSelected
                                                                                        ? colors?.colorFont || '#0d6efd'
                                                                                        : colors?.grColorFont || '#212529'
                                                                                }}>
                                                                                {rigData.name}-{well.name}
                                                                            </div>
                                                                            <div className="d-flex align-items-center">
                                                                                <i className={`fas fa-circle me-2 ${well.tx ? 'text-success' : 'text-danger'}`} style={{ fontSize: '10px' }}></i>
                                                                                <span className={`badge ${well.tx ? 'bg-success' : 'bg-danger'}`}>
                                                                                    {well.tx ? 'Online' : 'Offline'}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="small mb-2" style={{
                                                                            color: colors?.grColorFont ? `${colors.grColorFont}99` : '#6c757d',
                                                                            opacity: 0.9
                                                                        }}>
                                                                            {hasDescription && (
                                                                                <div className="mb-1">
                                                                                    <i className="fas fa-info-circle me-1"></i>
                                                                                    {well.description}
                                                                                </div>
                                                                            )}
                                                                            <div className="row">
                                                                                <div className="col-6">
                                                                                    <i className="fas fa-play-circle me-1"></i>
                                                                                    Inicio: {well.startDate}
                                                                                </div>
                                                                                <div className="col-6">
                                                                                    <i className="fas fa-satellite-dish me-1"></i>
                                                                                    Última: {well.lastTransmission}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <small style={{
                                                                    color: colors?.grColorFont ? `${colors.grColorFont}99` : '#6c757d',
                                                                    opacity: 0.8
                                                                }}>
                                                                    <i className="fas fa-hand-pointer me-1"></i>
                                                                    Clic aquí para seleccionar el pozo
                                                                </small>
                                                                <div className="btn-group btn-group-sm" role="group">
                                                                    <button
                                                                        className="btn btn-outline-info btn-sm"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleNavigation(well.id, 'livegraphsopt');
                                                                        }}
                                                                        title="Gráficas en Tiempo Real"
                                                                    >
                                                                        <i className="fas fa-chart-line"></i>
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-outline-primary btn-sm"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleNavigation(well.id, 'livedataopt');
                                                                        }}
                                                                        title="Datos en Tiempo Real"
                                                                    >
                                                                        <i className="fas fa-table"></i>
                                                                    </button>
                                                                    {(tipo === '1' || reportes === 1) && (
                                                                        <button
                                                                            className="btn btn-outline-success btn-sm"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleNavigation(well.id, 'doreport');
                                                                            }}
                                                                            title="Reporte Operacional Diario"
                                                                        >
                                                                            <i className="fas fa-book"></i>
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
    )
};

export default Home
